import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { focusAnswer } from 'app/modules/subject';
import { useLayoutEffect } from 'react';

/**
 * Focus the answer field while page changed and the first subject of the page is focusable.
 */
export function useAutoFocusOnDidMount() {
  const engine = useEngineInstance();
  const id = useSubjectId();

  useLayoutEffect(() => {
    const { multiplePages } = engine.getSurveyData();
    if (multiplePages) {
      const { pages, current } = engine.getPagination();
      const list = pages[current];

      if (list[0] === id && engine.isFocusable(id)) {
        focusAnswer(id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
